import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import DateRangePicker from "@/components/date-range-picker-local/components/DateRangePicker.vue";
import EmailModalPopupComponent from "../email-modal-popup/email-modal-popup.component.vue";
import { getApplicationDetails } from "@/providers/apis/getApplictionDetails";
import { endorsementFormApi } from "@/providers/apis/endorsement-form";
import { utils } from "@/utils/utils";
import { appConfigService } from "@/providers/services/app/app-config";
import {
  User,
  dateRange,
  reviewerDataTable,
} from "@/models/common-interface/common.interface";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import {
  FilterStateStorageNames,
  SortingKeyName,
  SortingOrderKey,
  TableSortEvent,
} from "@/models/constants/filters.interface";

@Component({
  name: "reviewer-endorsement-page",
  components: {
    AppLoaderComponent,
    DateRangePicker,
    EmailModalPopupComponent,
    ErrorPopupComponent,
  },
})
export default class ReviewerEndorsementPage extends Vue {
  public endorsementData: any[] = [];
  public limit = 10;
  public offset = 0;
  public currentPage = 1;
  public totalItem = 0;
  public page = 1;
  public filterDetails: any = {};
  public isLoading = true;
  public isDataEmpty = false;
  public startDate: any;
  public endDate: any;
  public endorsementEmailData: any = null;
  public statusFilterData = "";
  public toogleStatus = false;
  public sort = SortingKeyName.updatedAt;
  public sortBy = SortingOrderKey.DESC;
  public localeDate = {
    format: "yyyy-m-dd",
    applyLabel: "Apply",
    firstDay: 0,
  };
  public dateRange: dateRange = {} as dateRange;
  public timePicker = false;
  public dateFilter = "";
  public tableFields = [
    {
      key: "submittedAt",
      label: "Submission Date",
      sortable: true,
      thClass: "application_date",
    },
    { key: "firstName", label: "Applicant First Name", sortable: true },
    { key: "lastName", label: "Applicant Last Name", sortable: true },
    {
      key: "email",
      label: "Email Address",
      sortable: true,
      thClass: "email",
      tdClass: "email",
    },
    {
      key: "trainingStatus",
      label: "Training Status",
      sortable: false,
      thClass: "application_status",
      tdClass: "training-status-cell",
    },
    {
      key: "progressStatus",
      label: "Approval Status",
      sortable: true,
      thClass: "application_status",
      tdClass: "progress-status",
    },
    {
      key: "action",
      label: "Action",
      sortable: false,
      thClass: "application_action pointer-events",
      tdClass: "actions",
    },
  ];
  public applyStatusFilter: any = [];
  public selected: any = [];
  public options = [
    { text: "Received", value: "RECEIVED" },
    { text: "Need More Info", value: "NEED MORE INFO" },
    { text: "Processing", value: "PROCESSING" },
    { text: "Accepted", value: "ACCEPTED" },
    { text: "Not Accepted", value: "NOT ACCEPTED" },
    { text: "Completed Training", value: "COMPLETED TRAINING" },
    { text: "Waiting For Training", value: "WAITING FOR TRAINING" },
  ];
  public userDetails!: User;
  public errorMessage = "";
  public showDelete = appConfigService.getShowDelete();
  public deleteTargetId = "";
  public deleteFirstName = "";
  public deleteLastName = "";
  public deleteSubmittedAt = "";
  public deleteEmail = "";
  public deleteProgressStatus = "";
  public deleteSuccess = false;

  public created() {
    if (this.$route.query.status) {
      const status: string = this.$route.query.status as string;
      this.toogleStatus = !this.toogleStatus;
      this.selected = [status];
      this.onApplyFilter();
    } else {
      const saved = sessionStorage.getItem(FilterStateStorageNames.ENDORSEMENT)
        ? JSON.parse(
            sessionStorage.getItem(FilterStateStorageNames.ENDORSEMENT) || ""
          )
        : null;
      if (saved) {
        this.filterDetails = { ...this.filterDetails, ...saved };
        this.selected = this.filterDetails.status
          ? typeof this.filterDetails.status === "string"
            ? this.filterDetails.status.split(",")
            : this.filterDetails.status
          : [];
        this.toogleStatus = !this.toogleStatus;
        sessionStorage.removeItem(FilterStateStorageNames.ENDORSEMENT);
      } else {
        this.selected = this.options
          .map((s) => {
            if (!["Not Accepted", "Accepted"].includes(s.text)) return s.value;
          })
          .filter((v) => v !== undefined);
        this.toogleStatus = !this.toogleStatus;
      }
      this.applyExistingFilters();
    }
    this.userDetails = utils.getUserDetails();
  }

  public updated() {
    window.document.onclick = (event) => {
      if (this.toogleStatus) {
        const el = document.getElementsByClassName("filter-status")[0];
        if (el && !el.contains(event.target as Node)) {
          this.toogleStatus = !this.toogleStatus;
        }
      }
    };
  }

  public applyExistingFilters() {
    this.toogleStatus = !this.toogleStatus;
    this.applyStatusFilter = this.selected;
    this.statusFilterData = this.applyStatusFilter.join(",");
    this.limit = this.filterDetails.limit || this.limit;
    this.offset = this.filterDetails.offset || this.offset;
    this.currentPage = (this.offset + this.limit) / 10;
    if (this.filterDetails?.from && this.filterDetails?.to) {
      this.dateRange.startDate = new Date(this.filterDetails.from);
      this.dateRange.endDate = new Date(this.filterDetails.to);
      this.startDate = moment(new Date(this.dateRange.startDate)).format(
        "MM-DD-YYYY"
      );
      this.endDate = moment(new Date(this.dateRange.endDate)).format(
        "MM-DD-YYYY"
      );
      this.dateFilter = this.startDate + " - " + this.endDate;
    }
    this.getEndorsementApplicationLists();
  }

  public onClearFilter() {
    if (this.$route.query.status) {
      this.$router.replace("/reviewer-dashboard/cprs-j");
    }
    this.offset = 0;
    this.currentPage = 1;
    this.toogleStatus = !this.toogleStatus;
    this.selected = [];
    this.applyStatusFilter = [];
    this.isLoading = true;
    this.statusFilterData = "";
    this.getEndorsementApplicationLists();
  }

  public onApplyFilter() {
    this.offset = 0;
    this.currentPage = 1;
    this.toogleStatus = !this.toogleStatus;
    this.applyStatusFilter = this.selected;
    this.statusFilterData = this.applyStatusFilter.join(",");
    this.getEndorsementApplicationLists();
  }

  public onClearStatusFilter(isDateFilter = false, index: any) {
    if (this.$route.query.status) {
      this.$router.replace("/reviewer-dashboard/cprs-j");
    }
    if (isDateFilter) {
      this.dateFilter = "";
      this.startDate = "";
      this.endDate = "";
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;
    } else {
      this.applyStatusFilter.splice(index, 1);
      this.selected = this.applyStatusFilter;
      this.statusFilterData = this.applyStatusFilter.join(",");
    }
    this.offset = 0;
    this.currentPage = 1;
    this.getEndorsementApplicationLists();
  }

  public onClearAllFilterStatus() {
    if (this.$route.query.status) {
      this.$router.replace("/reviewer-dashboard/cprs-j");
    }
    this.offset = 0;
    this.currentPage = 1;
    this.dateRange.startDate = null;
    this.dateRange.endDate = null;
    this.startDate = "";
    this.endDate = "";
    this.dateFilter = "";
    this.selected = [];
    this.applyStatusFilter = [];
    this.statusFilterData = "";
    this.filterDetails.firstName = "";
    this.filterDetails.lastName = "";
    this.filterDetails.email = "";
    this.sort = SortingKeyName.updatedAt;
    this.sortBy = SortingOrderKey.DESC;
    this.getEndorsementApplicationLists();
  }

  public loadContent(page: number) {
    this.page = page;
    this.offset = (this.page - 1) * this.limit;
    this.getEndorsementApplicationLists();
  }

  public sortChanged(event: TableSortEvent) {
    if (event) {
      this.offset = 0;
      this.currentPage = 1;
    }
    if (
      event.sortBy &&
      SortingKeyName[event.sortBy as keyof typeof SortingKeyName] !== undefined
    ) {
      this.sort = SortingKeyName[event.sortBy as keyof typeof SortingKeyName];
      this.sortBy = event.sortDesc ? SortingOrderKey.DESC : SortingOrderKey.ASC;
    }
    this.getEndorsementApplicationLists();
  }

  public dateChip() {
    if (this.dateRange) {
      this.startDate = moment(new Date(this.dateRange.startDate)).format(
        "MM-DD-YYYY"
      );
      this.endDate = moment(new Date(this.dateRange.endDate)).format(
        "MM-DD-YYYY"
      );
    }
    this.offset = 0;
    this.currentPage = 1;
    this.dateFilter = this.startDate + " - " + this.endDate;
  }

  public getEndorsementApplicationLists() {
    this.filterDetails.limit = this.limit;
    this.filterDetails.offset = this.offset;
    this.filterDetails.from = this.startDate;
    this.filterDetails.to = this.endDate;
    this.filterDetails.status = this.statusFilterData;
    this.filterDetails.sort = this.sort;
    this.filterDetails.sortBy = this.sortBy;

    const email = this.filterDetails.email
      ? encodeURIComponent(this.filterDetails.email)
      : null;

    this.isLoading = true;
    getApplicationDetails
      .getEndorsementApplicationList({ ...this.filterDetails, email })
      .then((data) => {
        this.isLoading = false;
        this.endorsementData = data.list;
        this.totalItem = data.totalCount;
        this.isDataEmpty = !this.endorsementData.length;
        this.endorsementData.forEach((el: any) => {
          el.submittedAt = moment(el.submittedAt).format("MM-DD-YYYY");
        });
      })
      .catch((error) => {
        this.isDataEmpty = true;
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public previewForm(row: any) {
    sessionStorage.setItem(
      FilterStateStorageNames.ENDORSEMENT,
      JSON.stringify(this.filterDetails)
    );
    this.$router.push({ path: `cprs-j/${row.item.id}` });
  }

  public onOpenModal(row: any) {
    this.endorsementEmailData = row;
    this.$bvModal.show("email-modal");
  }

  public emailSentStatus(event: boolean) {
    if (event) {
      this.$bvModal.hide("email-modal");
    }
  }

  public formTypeTableRowClass(item: reviewerDataTable, type: string) {
    return utils.formTypeTableRowClass(item, type);
  }

  // Map the stored training-status codes to human-readable labels for the list.
  public trainingStatusLabel(value: string): string {
    const labels: { [key: string]: string } = {
      NOT_STARTED: "Not Started",
      IN_PROGRESS: "In Progress",
      COMPLETED: "Completed",
    };
    return labels[value] || value;
  }

  // Reuse the Approval Status pill styles: Not Started -> received,
  // In Progress -> more-info, Completed -> accepted.
  public trainingStatusClass(value: string): string {
    const v = (value || "").toUpperCase();
    if (v === "IN_PROGRESS" || v === "IN PROGRESS") return "more-info";
    if (v === "COMPLETED" || v === "COMPLETED TRAINING") return "accepted";
    return "received";
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }

  public confirmDelete(row: any) {
    this.deleteTargetId = row.item.id;
    this.deleteFirstName = row.item.firstName;
    this.deleteLastName = row.item.lastName;
    this.deleteSubmittedAt = row.item.submittedAt;
    this.deleteEmail = row.item.email;
    this.deleteProgressStatus = row.item.progressStatus;
    this.deleteSuccess = false;
    this.$bvModal.show("delete-application-modal-endorsement");
  }

  public cancelDelete() {
    this.deleteSuccess = false;
    this.$bvModal.hide("delete-application-modal-endorsement");
  }

  public submitDelete() {
    this.isLoading = true;
    endorsementFormApi
      .deleteEndorsementApplication(this.deleteTargetId)
      .then(() => {
        this.isLoading = false;
        this.deleteSuccess = true;
        this.getEndorsementApplicationLists();
        setTimeout(() => {
          this.$bvModal.hide("delete-application-modal-endorsement");
          this.deleteSuccess = false;
        }, 5000);
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }
}
